import {Observable, throwError} from "rxjs";
import {Injectable} from "@angular/core";
import {User} from "../interfaces";
import {HttpClient} from "@angular/common/http";

import {catchError, tap} from "rxjs/operators";
  import { GoogleAnalyticsService } from '../../@core/utils/analytics.service';
 


@Injectable({providedIn: 'root'})
export class AuthService {


 private token = null 
	private baseUrl: string = '';  
	public userData: any = {}
	public blockedUser:boolean = false
	public blockedByPayment:boolean = false
	public userDataLoaded: boolean = false

	public role: string = ''
	public balance:number = 0       
	//public storageUsed:any = 0
	//public mediaUsed:any = 0
       // public mediaPrice:number = 0
        // public storagePrice:number = 0
        //public mediaForPay:any = 0
       // public storageForPay:any = 0



        public tariffsList: any
        public currentTariff: any
        public retentionStatus: any = null
        public storageStatus: any = null
        public storageAddonPrice: any = null
        public storageBlocked: boolean = false
        public storageWarnAfterCreate: boolean = false




  constructor(private http: HttpClient,    public gAnalytics: GoogleAnalyticsService){

    const potentialToken = localStorage.getItem('auth-token')
    if(potentialToken !== null){
      this.setToken(potentialToken)

    }
  }

  setToken(token: string){
    this.token = token
  }


  setBalance(balance: number){
   
	this.balance = balance
  }


   get priceLimit(){
 
	
	return this.currentTariff?.isFree ? 10 : 0

  }


  get restreamsLimit(){
 
	return this.currentTariff?.restreamThreadLimit || 1

  }



 
setBlockedByPayment(blockedByPayment){
   
	this.blockedByPayment = blockedByPayment
  }


  /*
  setStorageUsed(s: any){
   
	this.storageUsed = s
 
		let h  : any  = Math.floor(s / 3600);
		let m  : any  = Math.floor(s % 3600 / 60);  
		//    var s = Math.floor(d % 3600 % 60);
			let sc : any = Math.floor(s % 3600 % 60);
 
		 if(parseInt(sc) < 10){sc = '0'+sc}

                 if(parseInt(m) < 10){m = '0'+m}
		this.storageUsed = `${h}:${m}`
 
		
			let pricePerSeconds = (this.storagePrice / 3600)
                        
 
                        
			this.storageForPay = parseFloat((s * pricePerSeconds).toFixed(2)) 
 
  }


  setMediaUsed(s: any){

	 
			 let h : any = Math.floor(s / 3600);
		      let m : any  = Math.floor(s % 3600 / 60);  
 			let sc : any = Math.floor(s % 3600 % 60);
 
		 if(parseInt(sc) < 10){sc = '0'+sc}

				if(parseInt(m) < 10){m = '0'+m}
			this.mediaUsed = `${h}:${m}`  
 
			let pricePerSeconds = (this.mediaPrice / 3600)
                        
 
                        
			this.mediaForPay = parseFloat((s * pricePerSeconds).toFixed(2)) 

			 
 
	}

 */

  login(user:User):Observable<any>{
   return  this.http.post<any>(this.baseUrl + `/api/auth/login`, user)
     .pipe(
       tap((data)=> {
 
         localStorage.setItem('auth-token', data.token)
         this.setToken(data.token)
	        this.role = data.role
	        this.userData = data.userData
	      	this.userDataLoaded = true
		this.blockedUser = data.blocked
		
		
               // this.mediaPrice = data.mediaPrice
               // this.storagePrice = data.storagePrice
                this.blockedByPayment = data.blockedByPayment
		this.balance = data.balance //|| 3500000 
		//this.setMediaUsed(parseInt(data.mediaUsed).toFixed(0) || 0)
		//this.setStorageUsed(parseInt(data.storageUsed).toFixed(0) || 0)
		if(data.gaReg === true){ this.gAnalytics.trackEvent('Hello') }
		this.tariffsList = data.tariffsAvailable || []
		this.currentTariff =  data.userTariff || {}
		


		
       }),
       catchError(error=>throwError(error))
     )

  }

    getUserData(){
      if(this.userData){
        return this.userData
      }

   }

    loadUserData():Observable<any>{
   return  this.http.get<any>(this.baseUrl + `/api/auth/get_user_data`)
     .pipe(
       tap((data:any)=> {
          if(data){
            this.userData = data.userData
            this.role = data.role
            this.userDataLoaded = true


	    //this.mediaPrice = data.mediaPrice
            //this.storagePrice = data.storagePrice
            this.blockedUser = data.blocked
	    this.blockedByPayment = data.blockedByPayment
            this.balance = data.balance //|| 3500000
	  //  this.setStorageUsed(parseInt(data.storageUsed).toFixed(0) || 0)
	  //  this.setMediaUsed(parseInt(data.mediaUsed).toFixed(0) || 0)
	    this.tariffsList = data.tariffsAvailable || []
	    this.currentTariff =  data.userTariff || {}

          }
       }),
       catchError(error=>throwError(error))
     )

  }


  loadRetentionStatus():Observable<any>{
    return this.http.get<any>(this.baseUrl + `/api/auth/retention_status`)
      .pipe(
        tap((data:any)=>{
          this.retentionStatus = data || null
        }),
        catchError(error => {
          this.retentionStatus = null
          return throwError(error)
        })
      )
  }
 




  setBlockedStatus(status: boolean){
    this.blockedUser = status
  }

	setNewPicture(image){
		 
		if(this.userData?.picture != image){
			this.userData.picture = image || ''

		}
	}
	setNewChannelUrl(url){
		 
		if(this.userData?.channelUrl != url){
			this.userData.channelUrl = url || ''

		}
	}


//



  registration(user:User): Observable<User>{
    return this.http.post<User>(this.baseUrl + '/api/auth/register',user)
  }



  changePassword(data:any) : Observable<any>{
    return this.http.post<any>(this.baseUrl + '/api/auth/change_password',data)
  }



  generatePassword() : Observable<any>{
    return this.http.post<any>(this.baseUrl + '/api/auth/generate_new_password',{})
  }



  resetPassword(user:any) : Observable<any>{
    return this.http.post<any>(this.baseUrl + '/api/auth/reset_password',user)
  }


   getPaymentData(price:number, basePath:string = 'overview', promocode:string = ''):any{
	 
    return this.http.post<any>(this.baseUrl + '/api/payments/request_pay',{price: price, basePath, promocode})
	 
   }


  /* requestBuyTariff(id:any,months:number, basePath:string = 'overview'):any{
	 
    return this.http.post<any>(this.baseUrl + '/api/payments/request_buy_tariff',{tariff: id, months, basePath })
	 
   }*/

   requestBuyTariff(id:any):any{
	 
    return this.http.post<any>(this.baseUrl + '/api/payments/request_buy_tariff',{tariff: id })
	 
   }


  isAdmin(){

	return this.role === 'Admin'
  }


  getToken():string{
    return this.token
  }

  isAuthenticated(){
    return !!this.token
  }
  logout(){
    this.setToken(null)
    localStorage.removeItem('auth-token')
    // Storage state belongs to the account that just left, not to whoever logs
    // in next in the same browser session.
    this.storageStatus = null
    this.storageAddonPrice = null
    this.storageBlocked = false
    this.storageWarnAfterCreate = false
  }



  loadStorageStatus():Observable<any>{
    return this.http.get<any>(this.baseUrl + `/api/auth/storage_status`)
      .pipe(
        tap((data:any)=>{
          this.storageStatus = data || null
          if(this.storageStatus && !this.storageAddonPrice){ this.loadStorageAddonPrice().subscribe(()=>{}, ()=>{}) }
        }),
        catchError(error => { this.storageStatus = null; return throwError(error) })
      )
  }

  loadStorageAddonPrice():Observable<any>{
    return this.http.get<any>(this.baseUrl + `/api/auth/storage_addon_price`)
      .pipe(
        tap((data:any)=>{ this.storageAddonPrice = data || null }),
        catchError(error => { this.storageAddonPrice = null; return throwError(error) })
      )
  }

  buyStorageTb():Observable<any>{
    return this.http.post<any>(this.baseUrl + `/api/auth/storage_addon_buy`, {})
      .pipe(
        tap((data:any)=>{ if(data && typeof data.balance === 'number'){ this.balance = data.balance } }),
        catchError(error => throwError(error))
      )
  }

}
